import React, { useState, useEffect } from 'react';
import { Users, X } from 'lucide-react';

const SocialProofPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState(null);

  const notifications = [
    { name: 'Ahmad', location: 'Jakarta', time: '5 menit yang lalu' },
    { name: 'Siti', location: 'Surabaya', time: '3 menit yang lalu' },
    { name: 'Budi', location: 'Bandung', time: '7 menit yang lalu' },
    { name: 'Rina', location: 'Medan', time: '2 menit yang lalu' },
    { name: 'Fajar', location: 'Yogyakarta', time: '10 menit yang lalu' },
    { name: 'Dewi', location: 'Bali', time: '4 menit yang lalu' },
    { name: 'Arif', location: 'Semarang', time: '6 menit yang lalu' },
    { name: 'Maya', location: 'Makassar', time: '8 menit yang lalu' }
  ];

  useEffect(() => {
    // Show first notification after 3 seconds
    const initialTimeout = setTimeout(() => {
      showRandomNotification();
    }, 3000);

    return () => clearTimeout(initialTimeout);
  }, []);

  const showRandomNotification = () => {
    const randomNotif = notifications[Math.floor(Math.random() * notifications.length)];
    setCurrentNotification(randomNotif);
    setIsVisible(true);

    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 5000);

    // Show next notification after 15-25 seconds
    const nextDelay = Math.random() * 10000 + 15000;
    setTimeout(() => {
      showRandomNotification();
    }, nextDelay);
  };

  if (!isVisible || !currentNotification) return null;

  return (
    <div className="fixed bottom-6 left-4 md:left-6 z-50 animate-slide-in-left">
      <div className="bg-white rounded-xl shadow-2xl border-2 border-[#ED1C24]/20 p-4 max-w-[280px] md:max-w-sm">
        <div className="flex items-start space-x-3">
          <div className="bg-gradient-to-br from-[#ED1C24] to-[#c91820] w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center flex-shrink-0">
            <Users className="w-5 h-5 md:w-6 md:h-6 text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm md:text-base font-bold text-black mb-1">
              {currentNotification.name} dari {currentNotification.location}
            </p>
            <p className="text-xs md:text-sm text-gray-600">
              baru bergabung ke Sinyal Bank Entry!
            </p>
            <p className="text-xs text-gray-400 mt-1">{currentNotification.time}</p>
          </div>
          <button
            onClick={() => setIsVisible(false)}
            className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SocialProofPopup;